import { BaseConnector } from './baseConnector';

class InvitationGroupMappingConnector extends BaseConnector {
  updateInvitationGroupMappings(hearingTypeId, dtos) {
    var url = `${this.baseApiUrl}/hearingType/${hearingTypeId}/InvitationGroupMappings`;
    return this.authPatch(url, dtos);
  }
}

export { InvitationGroupMappingConnector };
